export const locale = {
  lang: 'tr',
  data: {
    'REQUERIMIENTOS': {
      'BOTONES':{
        'SIGUIENTE': 'Sonraki',
        'ANTERIOR': 'Önceki',
        'ACEPTAR': 'Teknik Şartları kabul ediyorum',
        'FINALIZAR': 'Önceki'
      },
      'MENSAJES': {
        'CONFREQ': 'Platform teknik gereksinimlerini başarıyla kabul ettiniz',
        'OK': 'tamam',
      },
      'CABECERA':{
        'TITULO': 'IT gereklilikleri',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'PASO1':{
        'TITULO': 'Çalışan gereklilikleri',
        'SUB_TITULO': '1.Başvuru için Gerekenler',
        'SUB_TITULO2': '2.Tarayıcı Kapasitesi Gereklilikleri',
        'TABLE_REQUERIMIENTOS' : {
          'TD_SISTEMAS': 'İşletim Sistemleri',
          'TD_LABEL_RECOMENDADO': 'veya üstü (ÖNERİLEN)',
          'TD_NAVEGADOR': 'Tarayıcı',
          'TD_LABEL_SUPERIOR': 'veya üstü',
          'TD_LABEL_LASTVERSION': '(son sürümü)',
          'TD_LABEL_LASTVERSION_MIN': '(son sürümü, en düşük 12.3 versiyonu)'
        },
        'TABLE_REQUISITOS' : {
          'TD_CERTIFICAR': 'Güvenlik Sertifikası',
          'TD_COOKIES': 'Çerezlere izin verilmesi',
          'TD_CIFRADO': 'TLS şifrelemesi',

          'TD_CONTENT1': 'Şirketinizdeki güvenlik sertifikası veya otoritesinin Let’s Encrypt Authority’yi güvenli olarak sınıflandırdığından emin olun.',
          'TD_CONTENT2': 'Tarayıcının JavaScript 1.2’yi desteklemesi gerekmektedir.',
          'TD_CONTENT3': 'CulturalGo Platformu sunucuları, kullanıcıdan veya işletim sisteminden bilgi toplamayan çerezleri işler. Ancak, anketin çalışması için gereklidirler ve etkinleştirilmelidirler.',
          'TD_CONTENT4': 'Proje türüne bağlı olarak, rapor modüllerimizden biri yalnızca TLS şifrelemesi gerektirir.'
        },
        'PARRAFO1': {
          'SUBPARRAFO1': 'Eğer müşteri LINUX, UNIX, ChromeOS veya diğer mobil platformlar gibi farklı bir işletim sistemi kullanmayı tercih ediyorsa, anketin tarayıcı yazılımı ile doğru çalışmasının sorumluluğu kendisine aittir.',
          'SUBPARRAFO2': 'POODLE Zaafiyeti (CVE-2014-3566) ve Microsoft’un Windows XP’den desteğini çekmesine karşılık olarak Great Place, Windows XP kullanan bilgisayarlardan güvenli web sitelerimize erişimi desteklemeyecektir. Great Place, başvuru gerekliliklerinde belirtilen Chrome ve Firefox tarayıcılarının uygun versiyonlarını kullanan Windows XP bilgisayarlara destek vermeyi sürdürecektir. Diğer tarayıcılardan erişim sağlanması mümkündür; fakat bu tarayıcılar test edilmeyecek ve desteklenmeyecektir.'
        },
        'ADVERT': 'NOT: Cultural Go\'nun 5.0 sürümünden itibaren Microsoft Internet Explorer desteği kaldırılmıştır.'
      },
      'PASO2':{
        'TITULO': 'BT Gereksinimleri',
        'SUB_TITULO1': '3.Sertifikalar',
        'SUB_TITULO2': '4.Katılımcının dizüstü bilgisayarı / bilgisayarı',
        'SUB_TITULO3': '5.Mobil cihazlardan anket yanıtlanması',
        'SUB_TITULO4': '1.Dikkate alınacak konular',
        'SUB_TITULO5': '2. Dil yardımı',
        'PARRAFO1': 'Cultural GO, Internet Security Research Group (ISRG) tarafından sağlanan Lets Encrypt Authority) <3 SSL Sertifikası kullanmaktadır. Sertifika yüklü değilse, kullanıcıya web sitesinin güvenlik sertifikasında bir sorun olduğunu bildiren bir güvenlik uyarı sayfası görüntülenir. Kullanıcı web sitesine erişmeye devam etmeyi veya sorun hakkında daha fazla bilgi görüntülemeyi seçebilir. Kullanıcının web sitesinde gezinmesine izin verilmesine rağmen, kullanıcı siteyi her ziyaret ettiğinde uyarı mesajı görünmeye devam eder.',
        'PARRAFO2':{
          'LINEA1':'Çevrimiçi ankete erişmek için, çalışanın bilgisayarının / dizüstü bilgisayarının şunlara ihtiyacı vardır:',
          'LINEA2':'Anketin web adresine tam erişim (Lütfen güvenlik duvarına sahip olması durumunda kullanıcının uygun izinlere sahip olduğundan emin olun.)',
          'LINEA3':'Anket linkinin e-posta ile gönderilmesi durumunda, kullanıcının kurumsal e-posta hesabına erişimi olmalıdır.',
        },
        'PARRAFO3': 'Anketler, tabletler ve telefonlar gibi mobil cihazlarda doldurulabilir. Anket öğelerinin sunumu ve düzenlenmesi, cihazın ekran çözünürlüğü ile uyumlu olacaktır. Anketin açılabilmesi ve uygulanabilmesi cihazın modeline bağlıdır.',

        'PARRAFO4': 'Anket, Full HD Çözünürlüklü mobil cihazların dikey ekranlarında iyi bir kullanıcı deneyimine sahip olacak şekilde tasarlanmıştır.',

        'PARRAFO5': 'Birçok kuruluşta, WiFi ağları kişisel cihazlara tam erişim vermez, bu nedenle kullanıcı kişisel cihazını kullanmaya ve bir WiFi ağı üzerinden bağlanmaya karar verirse, anket web sitesine erişimi olduğundan emin olmalıdır.',

        'PARRAFO6': 'Kullanıcılar, cep telefonlarının data servisiyle bağlantı kurmaları durumunda navigasyon ücretlerinin uygulanabileceğini dikkate almalıdır.',
        'PARRAFO7':{
          'LINEA1':'Kullanıcılar, proje başına oluşturulacak belirli bir URL kullanarak siteye erişim kazanacaktır. ',
          'LINEA2':'Bağlantılarda kullanıcı bilgisi yoktur.Anket erişimini etkinleştirmek için güvenli genel URL ye özel bir kullanıcı şifresi girilmelidir.',
          'LINEA3':'Özel kullanıcı şifreleri kullanıcılara e-posta, SMS yoluyla veya İnsan Kaynakları Yöneticisi (veya eşdeğer konumdaki biri) aracılığıyla elden iletilecektir.',
        },
        'PARRAFO8':{
          'LINEA1':'Müşterinin anket davetiyesinin çalışanlara e-posta yoluyla iletilmesi sürecini gözlemlemesi gerekir:',
          'LINEA2':'E-posta sunucusu dış kaynaklı ise, iletimin sağlanması için gerekenleri bildirmek adına lütfen önceden e-posta sağlayıcısına başvurun.',
          'LINEA3':'E-posta sunucusu kurum içinde ise BT departmanından destek isteyin. ',
          'LINEA4':'M. Not: Anketi cevaplamak için davetiyelerin gönderilmesinde Hotmail Gmail, Yahoo, vb. ücretsiz servisler kullanılmamalıdır.',

          'LINEA5':'2. Müşteri kurumsal e-postası Outlook Webaccess ise, çalışanların web bağlantısını kopyalaması ve web tarayıcısında açması gerekir, aksi takdirde link hata verecektir.',
          'LINEA6':'3. Anketin doldurulduğu cihaz 30 dakikadan daha uzun süre açık bırakılıp uyku moduna geçerse "zaman aşımı" bildirimi gelir. Bu durumda kullanıcılar yine aynı kullanıcı adı ve şifre ile giriş yapmalıdır. Sistem kullanıcıları tam olarak kaldıkları soruya götürecektir.',
          'LINEA7':'4. Her cevap seçildiğinde kaydedilir. Kullanıcı, kaydetme işlemi tamamlanana kadar başka bir yanıt seçemeyecektir, böylece kullanıcının ankete yanıt verme sürecindeki ilerlemesi, seçilen tüm yanıtların kaydedilmiş olduğu anlamına gelir.',
        },
        'PARRAFO9':{
          'LINEA1':'Anketimiz yalnızca dil seçimi menüsünde belirlenen dilleri desteklemektedir ve dil seçimi yalnızca anketin başında yapılabilir.',
          'LINEA2':'Seçilen dillerin özel karakterler gerektiren başka bir dilde olması durumunda, kullanıcılar tarayıcılarının yazı tiplerini desteklediğinden emin olmalıdır.',
          'LINEA3':'Genellikle, anketi herhangi bir Doğu Asya dilinde veya özel karakterler gerektiren herhangi bir dilde görüntülemek isteyen tüm kullanıcıların hali hazırda dil paketleri yüklüdür, bu nedenle bunun birkaç kullanıcı haricinde yapılması gerekmeyebilir.',
          'LINEA4':'Proje bazlı olarak çevrimiçi sitede belirli bir yazı tipini kullanmak için, kullanıcıların ilgili makinelerinin her birinde o yazı tipinin yüklü olması gerekir. Gerektiğinde, Great Place bu gereksinimleri müşteri proje ekibine iletecektir.',
        },
        'PARRAFO10': 'Önemli: Kullanıcı, tarayıcının otomatik çeviri işlevinin etkin olmadığından emin olmalıdır, aksi takdirde dil seçimi çalışmayabilir.',
      },
      'PASO3':{
        'TITULO': 'BT Gereksinimleri ',
        'SUB_TITULO1': '1.SSI- şifreleme gereksinimleri',
        'SUB_TITULO2': '2. Bant genişliği gereksinimleri',
        'SUB_TITULO3': '3 Güvenlik Duvarı Beyaz Listesi: Web sunucusu IP si ve alan erişimi',
        'SUB_TITULO4': '4.Güvenlik Duvarı Beyaz Listeleri',
        'SUB_TITULO5': '5.Yanıt Gruplarının Üretimi (Kioskos)',
        'PARRAFO1': 'Katılımcının web tarayıcısı SSI nın etkin olduğu siteleri desteklemelidir. Bu, kullanıcının kişisel bilgilerin maksimum gizliliğini sağlar.',

        'PARRAFO2': 'Bant genişliği, dağıtılan anketin ve raporların türüne ve çözümde kullanılan bileşenlerin video, flash ve görüntülerine bağlıdır. Bu bileşenlerle yapılan anketler için önerilen bağlantı kullanıcı başına 1+ Mbit / s dir. Daha düşük bir bağlantı kullanılırsa kullanılabilirlik etkilenecektir. Bu bileşenlerin hiçbirine sahip olmayan anketler için normal bir internet bağlantısı gereklidir.',

        'PARRAFO3':{
          'LINEA1':"Cultural Go'da anket ve raporlama sitelerinin çalışabilmesi için  aşağıdakilerin beyaz listede olması gerekir:",
          'LINEA2':'Çalışanların Great Place to Work @ Trust Index © anketine erişmelerine izin vermek için aşağıdaki alanlara ve IP adreslerine gerekli izinleri vermek önemlidir.',
        },
        'PARRAFO31': 'Önemli: Alan adının tamamı kullanıcılar için kullanılabilir olmalıdır (sitenin tamamına erişim izni vermelidir). ',
        'PARRAFO4':{
          'LINEA1':'E-posta SunucusuPosta sunucusu, aşağıdaki e-posta adreslerine tam erişim verilmesini gerektirir:',
          'LINEA2':"Great Place'ten gelen e-postaların SPAM olarak sınıflandırılmasını önlemek için aşağıdakilere posta sunucunuzda izin verilmesi gerekir:",
        },
        'PARRAFO5':{
          'LINEA1':'Önemli::',
          'LINEA2':'Bu kurulum, e-posta adresinin SPAM olarak algılanmasını önlemek ',
          'LINEA3':'içindirPosta sunucusu aynı hesaptan binlerce e-posta alabilmelidir.',
          'LINEA4':'E-posta sağlayıcınızın güvenlik kurallarına, beyaz listeye eklemek üzere alan adlarını ekleyin ve mümkünse bunları kişi e-posta hesapları olarak ekleyin',
        },
        'PARRAFO6': 'Çok sayıda kuruluşta, kullanıcıların anketleri grup halinde cevaplayabilmeleri için birkaç bilgisayar yerleştirmek yaygındır. Bu nedenle, gruplar halinde giriş yapıldığında cihazların tüm trafiği destekleyeceğinden emin olmak için çıktıların bant genişliği testlerinin yapılması gerekir. ',
        'PARRAFO7': 'Kullanıcıların grup olarak yanıtlamaya başlamadan önce, bir BT alanı uzmanının internet bağlantısı sorunu olmayacağını doğrulaması önerilir.',
        'TABLA1':{
          'TD_ELEMENTO':'Element',
          'TD_REGION1':'Meksika',
          'TD_REGION2':'Orta ve Güney Amerika',
          'TD_REGION3':'Asya',
          'TD_REGION4':'Avrupa',
          'TD_DOMINIO':'Domain(alan)',
          'TD_SUBDOMINIO':'Sub-domain(alt alan)',
          'TD_DIRECCION':'IP Direction',
          'TD_PUERTOS':'Bağlantı noktaları',

        },
        'TABLA2':{
          'TD1':'Gönderen mail hesapları:',
          'TD2':'Domain(alan adı)'
        },
        'TABLADOMINIO':{
          'TD_ELEMENTO01':'Uygulama',
          'TD_ELEMENTO02':'Alan adı',
          'TD_ELEMENTO03':'IP',
          'TD_ELEMENTO04':'Giriş',
          'TD_ELEMENTO05':'Alt alan adı',
        },
        'TITLE1':'Alan adı: CulturalGo.com',
        'TITLE2':'Alan adı: gptw.global',
      },
      'PASO4':{
        'TITULO': 'BT Gereksinimleri',
        'SUB_TITULO1': '1.Destek',
        'SUB_TITULO2': '2.Sistem Kullanılabilirliği',
        'SUB_TITULO3': '3.Mücbir Sebep (overwhelming forces)',
        'SUB_TITULO4': '4.Eşzamanlılık ',
        'SUB_TITULO5': '5.Bakım penceresi',
        'TABLA1':{
          'TD_REGION1':'Meksika Bölgesi',
          'TD_REGION2':'Orta ve Güney Amerika Bölgesi',
          'TD_REGION3':'Asya Bölges.',
          'TD_REGION4':'Avrupa Bölgesi'
        },
        'PARRAFO1':{
          'LINEA1':'Uygulama kullanılabilirliği = %99.5',
          'LINEA2':'Sistem kullanılabilirliğini sağlamak için uygulama bir uyarı sistemi ve destek prosedürleri ile haftanın 7 günü, yılın 365 günü 24 saat izlenir.',
        },
        'PARRAFO2': 'Mücbir Sebep, doğal afetler, savaş, grevler, hükümet düzenlemeleri, sivil rahatsızlıklar veya terörizm veya deprem eylemleri dahil ancak bunlarla sınırlı olmamak üzere, yaşanmasının tarafların üzerlerine düşen görevleri yasal olarak uygulanamaz, yasadışı veya imkansız hale getirdiği olaylar anlamına gelir.',
        'PARRAFO3': 'Sistem kullanılabilirliği hizmeti, müşterinin burada belirtilen Teknik Gereksinimleri karşılamaması veya Mücbir Sebep olarak sınıflandırılan herhangi bir olaydan kaynaklanan hizmet eksikliklerini kapsamaz.',
        'PARRAFO4': "Veri toplama ortamı, 24 saatlik bir sürede 10.000 eşzamanlı kullanıcıyı veya 1.5 milyon adede kadar anketin tamamlanmasını destekleyebilir. Raporlama uygulaması, 24 saatlik bir süre içinde 500 eşzamanlı kullanıcıyı veya 1.000'e kadar rapor oturumunu destekleyebilir.",
        'PARRAFO5':{
          'LINEA1':'Great Place, planlı bakım için anket ve raporlama uygulamasını iptal etme hakkını saklı tutar. Programlı bakım uygulamaları, etkilenecek tüm taraflara önceden bildirilecektir.',
          'LINEA2':"Yukarıda belirtilen bakım penceresi sırasında, uygulama kullanıcılar tarafından kullanılamayabilir. Eğer Great Place'e ek faaliyetler için genişletilmiş bir bakım süresi gerekiyorsa, belirlenen süre kullanıcıya önceden bildirilir",
          'LINEA3':"Acil bakım gereken durumlarda önceden haber verilmeyebilir. Acil durumdan etkilenen kullanıcılara sistem durumu hakkında bilgilendirme yapılır."
        },
      },
      'PASO5':{
        'TITULO': 'BT Gereksinimleri',
        'SUB_TITULO1': '1.Politika',
        'PARRAFO1': 'CulturalGo Platformunun sunucularında gönderilen ve saklanan bilgiler, ISO 27001 hükümlerine uygun politikalar ve prosedürler kapsamında koruma altındadır. Herhangi bir sorunuz varsa, lütfen Great Place To Work danışmanınızla iletişime geçin..',
      },
      'VALIDACION':{
        'TITULO': 'Teknik gereksinimlerin doğrulanması',
        'DATOSTI':{
          'INFOEMPRESA': 'Şirket Bilgisi',
          'NOMBREEMPRESA': 'Şirketin adı',
          'NOMBRE': 'BT yöneticisi adı',
          'EMAIL': 'BT e-postası',
          'TEL': 'BT telefon numarası',
          'EXT': 'BT telefon numarası uzantısı',
          'CEL': 'BT cep telefonu numarası',
          'TOOLTIP': 'Şirket bilgilerini göster',
        },
        'TIMELINE':{
          'TITULO': 'Teknik gereklilik doğrulama süreci',
          'CARGANDO': 'Yükleme bilgileri',
          'PROGRESO': 'Mevcut ilerleme durumu:',
          'PROGRESO2': 'Teknik gereksinimler doğrulama ilerlemesi:',
          'STATUS': {
            'OK': 'Durum: Tamamlandı',
            'NOTOK': 'Durum: Tamamlanmadı',
            'TOOLTIP': 'Tamamlandı olarak işaretle',
          },
          'COMENTARIO': {
            'TITULO_1': 'Bu adım hakkında bir yorum kaydet',
            'INPUT': 'Yorumunuzu girin',
            'ENVIAR': 'Yorumu kaydet',
            'TITULO_2': 'Yorumlar (önce en eskisi)',
            'CANNOT': 'Adım tamamlandıktan sonra yorum gönderilemez',
          },
          'NOMBRES': {
            '1': 'TI yöneticisine e-posta gönderildi',
            '2': 'TR Kurulum - Müşteri çağrısı',
            '3': 'TR Kurulumu - Test',
            '4': 'Soru kağıdı gönderme',
            '5': 'Soru sayfası bitti',
          }
        },
        'MENSAJES': {
          'NADA': 'Henüz yorum girmediniz, boş bir yorum kaydedemeyebilirsiniz',
          'AUNNO': 'Bu işlemi henüz yapamazsınız, önce teknik gereksinimlerin doğrulanması tamamlanmalıdır',
          'COMPLETAR': 'Bu adımın durumunu "tamamlandı" olarak değiştirmeyi onaylıyor musunuz?',
          'COMPLETAR_OK': 'Bu adım başarıyla "Tamamlandı" olarak değiştirildi',
          'BOTONES': {
            'SI': 'Evet',
            'NO': 'Hayır',
          },
          'NOCOMPLETAR': 'Bu adımı yine de tamamlandı olarak işaretleyemezsiniz, önce bir önceki adımı tamamlamanız gerekir',
        }
      }
    },
    'REQUERIMIENTOSV3':{
      'MENSAJES':{
        'MENSAJE_SUCCESS_OK':'Teknik gereksinimler güncellendi',
        'MENSAJE_CONEX_OK':'Bağlantı başarılı',
        'ACTUALIZANDO_REQUERIMIENTOS': 'Teknik gereksinimleri güncelleme',
        'MENSAJE_RESPUESTA_REQ':'* Cevap gerekli',
        'WAR_ING_CORR ':' En az bir e-posta girin ',
      },
      'CABECERA':{
        'TITULO': 'Teknik gereksinimler',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
       'BOTONES':{
              'SIGUIENTE': 'Sonraki',
              'ANTERIOR': 'Önceki',
              'FINALIZAR': 'Bitiş',
              'ACEPTAR': 'Teknik gereksinimleri kabul ediyorum '
            },
        'PASO1':{
          'TITULO':'Katılımcı gereksinimleri',
          'SUB_TITULO':'Teknik gereksinimler',
          'SUB_TITULO2':'CulturalGo® Platform 5.0',
          'TEXTO0_PARTE_1':'Bu belgenin amacı, Greate Place to Work®, Trust Index © anket sistemine kolay ve etkili bir erişim sağlamak ve böylece tekrarlayan teknik sorunları önlemek için CulturalGo® platformunun teknik gereksinimleri hakkında bilgi vermektir.',
          'TEXTO0_PARTE_2':'Kuruluşunuzun ortak çalışanlarının anketi alması ve yanıtlaması için teknik gereksinimlerin her birine uymanız ve bunları doğrulamanız önemlidir. Aksi takdirde, işbirlikçinin anketi alamamasına ve yanıt verememesine neden olan tıkanmalar ve / veya arayüzler gibi komplikasyonlar ortaya çıkması çok olasıdır.',
          'SUB_TITULO3':'Katkıda Bulunan (Son Kullanıcı) Gereksinimleri',
          'SUB_TITULO4':'Uygulama Gereksinimleri',

          'SUB_TITULO2_CARCA':'CulturalGo® Platform 5.0',
          'TEXTO0_PARTE_1_CARCA':'Bu belgenin amacı, Innmotion, Trust Index © anket sistemine kolay ve etkili bir erişim sağlamak ve böylece tekrarlayan teknik sorunları önlemek için CulturalGo® platformunun teknik gereksinimleri hakkında bilgi vermektir.',
          'TEXTO0_PARTE_2_CARCA':'Kuruluşunuzun ortak çalışanlarının anketi alması ve yanıtlaması için teknik gereksinimlerin her birine uymanız ve bunları doğrulamanız önemlidir. Aksi takdirde, işbirlikçinin anketi alamamasına ve yanıt verememesine neden olan tıkanmalar ve / veya arayüzler gibi komplikasyonlar ortaya çıkması çok olasıdır.',

          'TABLE_REQUERIMIENTOS' : {
            'TD_SISTEMAS': 'İşletim sistemleri:',
            'TD_LABEL_RECOMENDADO': 'veya üstü (ÖNERİLEN).',
            'TD_NAVEGADOR': 'Tarayıcı:',
            'TD_LABEL_SUPERIOR': 'veya daha yüksek.',
            'TD_LABEL_LASTVERSION': '(son sürüm).',
            'TD_LABEL_LASTVERSION_MIN': '(en son sürüm, minimum sürüm 12.3).'
          },
          'TEXTO1_PARTE_1':'Müşteri, LINUX, UNIX, Chrome OS, mobil işletim sistemleri vb. Sürümleri gibi yukarıda listelenenlerin dışında başka bir işletim sistemi kullanmayı planlıyorsa, anketin tarayıcı yazılımında doğru şekilde çalışmasını sağlamak müşterinin sorumluluğundadır.',
          'TEXTO1_PARTE_2':'POODLE (CVE-2014-3566) güvenlik açığı ve Windows XP desteğinin Microsoft tarafından sonlandırılması nedeniyle, Great Place to Work® artık Windows XP çalıştıran bilgisayarlardan güvenli web sitelerimize erişimi desteklemeyecektir. Great Place to Work®, uygulama gereksinimlerinde listelenen Chrome veya Firefox tarayıcı sürümlerini kullanan Windows XP çalıştıran bilgisayarlar için destek sağlayacaktır. Yine de diğer tarayıcılardan erişim sağlanabilir; ancak bu tarayıcılar test edilmeyecek veya desteklenmeyecektir.',
          'TEXTO1_PARTE_2_INNO':'POODLE (CVE-2014-3566) güvenlik açığı ve Windows XP desteğinin Microsoft tarafından sonlandırılması nedeniyle, Innmotion artık Windows XP çalıştıran bilgisayarlardan güvenli web sitelerimize erişimi desteklemeyecektir. Innmotion, uygulama gereksinimlerinde listelenen Chrome veya Firefox tarayıcı sürümlerini kullanan Windows XP çalıştıran bilgisayarlar için destek sağlayacaktır. Yine de diğer tarayıcılardan erişim sağlanabilir; ancak bu tarayıcılar test edilmeyecek veya desteklenmeyecektir.',
          'TEXTO2_PARTE_1':'Not: Sürüm 5.0 CuturalGo® dan başlayarak, Microsoft Internet Explorer desteği kaldırılacaktır.',
        },
        'PASO2':{
          'TITULO': 'Anket Kimlik Doğrulaması',
          'SUB_TITULO1': 'Web sunucusu IP ve etki alanı erişimi',
          'SUB_TITULO2': ' Güvenlik Duvarı Beyaz Listeleri:',
          'TEXTO0_PARTE_1': 'Aşağıdakiler, anket ve rapor sitelerinin a Platform CulturalGo® üzerinde çalışması için beyaz listelerde görünmelidir:',
          'TEXTO1_PARTE_1': 'Çalışanlarınızın Great Place to Work® Trust Index © anketine erişmesine izin vermek için aşağıdaki etki alanlarına ve IP adresine gerekli izinleri vermek önemlidir.',
          'TEXTO1_PARTE_1_INNMO': 'Çalışanlarınızın  Innmotion Trust Index © anketine erişmesine izin vermek için aşağıdaki etki alanlarına ve IP adresine gerekli izinleri vermek önemlidir.',
          'BTN_COMPRO_CONEX':'Bağlantıyı kontrol et',
          'BTN_SUCCE_CONEX':'Bağlantı kuruldu',
          'TOOL_BTN_COMPRO_CONEX':'Yapım aşamasında hizmet',
          'MODAL_SUCCESS_CONEX':'Bağlantı başarılı oldu',
          'ETI_INTRUC_DOMA_COPY':'Herhangi bir merkezi olmayan erişim noktasından gelen bağlantıları doğrulamanız gerektiğinde bu bağlantıyı kopyalayın ve gönderin (Teknik Gereksinimlerin doğrulanmasını etkilemez).',
           'BTN_INTRUC_COPY_ENLA':'Bağlantıyı kopyala',
           'MODAL_COPY_ENLA_SUCC':'Bağlantı başarıyla kopyalandı',

           'SUB_TITULO2_CARCA': 'Firewall whilelists:',
           'TEXTO0_PARTE_1_CARCA': 'Aşağıdakiler, anket ve rapor sitelerinin a Platform CulturalGo® üzerinde çalışması için beyaz listelerde görünmelidir:',
           'TEXTO1_PARTE_1_CARCA': 'Çalışanlarınızın Great Place to Work® Trust Index © anketine erişmesine izin vermek için aşağıdaki etki alanlarına ve IP adresine gerekli izinleri vermek önemlidir.',

          'TABLE_CONTEN':{
           'TH_ELEMENTO':'Eleman',
           'TH_REGIONM':'Küresel Bölge',
           'TH_REGIONC':'Orta ve Güney Amerika Bölgesi',
           'TH_REGIONA':'Asya Bölgesi',
           'TH_REGIONE':'Avrupa Bölgesi',
           'TH_DOMINIO_PRINCIPAL':'Ana Alan',
           'TH_APLICADOR':'Anket Uygulayıcı',
           'TH_PLATAFORMA':'Yönetim Platformu',
           'TH_ENVOLTURA':'URL Sarma',
           'TH_RESULTADOS':'Sonuçlar (Tableau®)',
           'TH_CULTURE':'Kültür Denetimi®',
           'TH_PORTAL':'Harici sayım portalı',
           'TH_SUBDOMINIO':'Alt alan adı',
           'TH_DIRECCION_IP':'IP adresi',
           'TH_PUERTOS':'Portlar',
           'TH_DOMINIO':'Alan adı',
           'TEXTO1':'•	Anketlere giden tüm bağlantılar, her şirket için atanan anketin site sonunun yeniden yönlendirilmesini içeren 4all.gptw.global/ URL sarmalayıcısı aracılığıyla teslim edilecektir.',
           'TEXTO2':'• Güvenlik nedeniyle, CulturalGo® algoritmaları, anket süresi boyunca herhangi bir zamanda son anketin URL sini değiştirebilir. Bu nedenle, anket boyunca kalıcı olan 4all.gptw.global/ sarmalayıcı her zaman kullanılmalıdır. ',
           'TEXTO3':' ÖNEMLİ:',
           'TEXTO4':' Anket bağlantısına asla doğrudan erişilmemelidir (örneğin, http://newsurvey.culturalgo.com/Ax013s203ls), anketi oluşturan belirteç zaman zaman önceden haber verilmeksizin değişebilir.',
           'TEXTO5':' Önemli:',
           'TEXTO6':' Kullanıcılar, tüm etki alanına tam ve sınırsız (sınırsız) erişime sahip olmalıdır.',
           'TEXTO7':' e-posta sunucusu',
           'TEXTO8':' Posta sunucusu aşağıdaki e-posta adreslerine tam erişim gerektirir:',
           'TEXTO9':' Great Place to Work® e-postalarının SPAM olarak sınıfa gönderilmesini önlemek için posta sunucunuzda aşağıdaki izinler gereklidir:',
           'TEXTO9_INNMO':' Innmotion e-postalarının SPAM olarak sınıfa gönderilmesini önlemek için posta sunucunuzda aşağıdaki izinler gereklidir:',
           'TABLA_CONTENT2':{
             'TD_CUENTA_CORREO':' Gönderenin e-posta hesabı:',
             'TD_DOMINIO':' Alan adı:',
             'TD_IP_ADDRE_PRIM':'Birincil IP adresi:',
             'TD_SECON_IP':'İkincil IP adresleri:',
             'TD_SUBDOMINIO':'Bağlantıların yeniden yönlendirilmesi için alt alan adları (İzleme için kullanılırlar):',
           },
           'TEXTO10':'•	 Bu konfigürasyon, e-posta adresinin istenmeyen posta olarak algılanmasını önlemek içindir.',
           'TEXTO11':'•	Posta sunucusu aynı hesaptan binlerce e-posta alabilmelidir.',
           'TEXTO12':'•	E-posta sağlayıcınızın güvenlik kurallarında, beyaz liste için alan adlarını ekleyin ve mümkünse bunları iletişim e-posta hesapları olarak ekleyin',
           'TEXTO13':'Desteğe ihtiyacınız varsa mesaj atın',
           'BTN_CONFIGURACION':'Alanlar ve IPler yapılandırıldı',
           'BTN_ACCESO_ENCUESTA':'Testleri yaptım ve komplikasyon yaşamadım',
           'BTN_RECIBI_CORREOS':'E-postaları gelen kutuma aldım',

          }
        },
        'PASO3':{
          'TITULO':'Giriş Testleri',
          'TIT_TES_PRU_ACC_SURV': 'Bu bölümde, genel bir anketin görselleştirme testini gerçekleştirebileceksiniz (kuruluşunuzunkilerle ilgisi yoktur):',
          'INS2_TES_PRU_ACC_SURV ':' 1. üzerine tıklayın: ',
           'INS1_1_TES_PRU_ACC_SURV':'Anahtarı kopyala',
           'INS1_TES_PRU_ACC_SURV':' 2. Aşağıdaki bağlantıya erişin:',
           'INS3_TES_PRU_ACC_SURV ':' 3. Anahtarı şifre hücresine yapıştırın ',
           'INS4_TES_PRU_ACC_SURV ':' 4. Girişe tıklayın ',
          'TIT_TES_PRU_EM_PILO ':'Bu bölümde postanın kabulü için bir test yapabileceksiniz.',
           'INS1_TES_PRU_EM_PILO':' 1. E-postaları girin',
           'INS2_TES_PRU_EM_PILO':' 2. Test Postası Gönder düğmesine tıklayın',
           'BTN_SE_EMA':' Test postası gönderiliyor ',
           'CONTAC':'Teknik hatalar durumunda lütfen support@itbm.mx adresinden bizimle iletişime geçin, sorunu çözmekten memnuniyet duyarız.',
           'WARN_TEST_EMAIL':'İşleme devam etmek için size e-posta adresinize bir onay bağlantısı gönderdik',
           'MSJ_SUCC_EMA_': 'E-postalar başarıyla gönderildi',
           'MODAL_WARNI_BAND':'Sürece devam etmek için ankete erişimi ve / veya e-postanın alındığını onaylayın',
           'MSJ_COP_CLA': 'Kullanıcı anahtarı kopyalanıyor',
           'MODAL_VERIFI_INFO':'Bilgileri doğrulama',

           'MODAL_WARNI_EMAL':'IMPORTANT: This link should not be shared with the employees of the organization, because it is a test link in order to validate that the necessary permissions have been granted at the opening of the survey.',
           'CONTAC_CARCA':'Teknik hatalar durumunda lütfen soporte_ca@gptwonline.com adresinden bizimle iletişime geçin, sorunu çözmekten memnuniyet duyarız.',
           'WARN_TEST_EMAIL_CARCA':'İşleme devam etmek için size e-posta adresinize bir onay bağlantısı gönderdik',
           },
        'PASO4':{
          'TITULO':'Doğrulama Anketi',
          'PREGUNTAS':{
            'PREGUNTA_1':'1.-¿Ayarları sorunsuz bir şekilde yapıyor muyum?',
            'PREGUNTA_1_INDI':'(Herhangi bir sorununuz varsa lütfen belirtiniz)',
            'PREGUNTA_2':'2.-Posta sunucunuza şu kişi güveniyordu:',
            'PREGUNTA_2_INDI1':'a) Dahili BT ekibiniz (Konfigürasyonlar üzerinde tam kontrole sahiptir).',
            'PREGUNTA_2_INDI2':'b) Sağlayıcınızdan bir bilet talep ediyorum (sağlayıcının adını belirtin).',
            'PREGUNTA_3':'3.-¿E-postalarınız iş hesapları altında mı (Gmail, Microsoft, Yahoo !, vb.)?',
            'PREGUNTA_4':'4.-¿ Gptwonline.com etki alanını kaydettirdiniz mi, aldığınız e-postaların bu etki alanından olduğunu hatırladınız mı, spam veya istenmeyen postaya gitmediklerinden emin misiniz?',
            'PREGUNTA_5':'5.-¿Alınan e-postaların bir listesini (E-posta günlüğü) elde etmenin bir yolu var mı?',
            'PREGUNTA_6':'6.-¿Ortak çalışanlarınız hangi internet tarayıcılarını kurdu? (Lütfen listeleyiniz; Tarayıcı - versiyon)',
            'PREGUNTA_7':'7.-¿Çalışanlarınıza ankette gezinmeleri için gerekli izinleri verdiniz mi? (Sorun yaşarsam lütfen belirtin)',
            'PREGUNTA_8':'8.-¿Anketinizin uygulanması için, çalışanlarınızın anketinizi yanıtlamaları için planlanmış bilgisayar odalarınız var mı?',
            'PREGUNTA_8_INDI1':'(¿Varsa, lütfen oda sayısını ve oda başına ekipman sayısını belirtin?)',
          },
          'BTN_VALIDAR_ENVIAR':'Doğrula ve Gönder',
        },
        'PASO5':{
          'TITULO': 'Veri Gizliliği Politikası',
          'SUB_TITULO':'Veri Gizliliği Politikası',
          'PARRAFO1': 'CULTURAL GO® Platformunun sunucularında gönderilen ve saklanan bilgiler ISO 27001 ile uyumlu politikalar ve prosedürler kapsamında korunmakta ve korunmaktadır. Bununla ilgili herhangi bir sorunuz varsa lütfen Great Place To Work® danışmanınızla iletişime geçin.',
          'PARRAFO1_INNMO': 'CULTURAL GO® Platformunun sunucularında gönderilen ve saklanan bilgiler ISO 27001 ile uyumlu politikalar ve prosedürler kapsamında korunmakta ve korunmaktadır. Bununla ilgili herhangi bir sorunuz varsa lütfen Innmotion danışmanınızla iletişime geçin.',
          'PARRAFO2':'Tescilli Ticari Markalar',
          'PARRAFO3_1':'•	Great Place to Work® ve Trust Index © ',
          'PARRAFO3_2':'Great Place To Work Institute USA nın tescilli ticari markalarıdır, bu belgede bu markalar sadece referans olarak kullanılmıştır.',
          'PARRAFO3_1_INNMO':'•	Innmotion ve Trust Index © ',
          'PARRAFO3_2_INNMO':'Innmotion Institute USA nın tescilli ticari markalarıdır, bu belgede bu markalar sadece referans olarak kullanılmıştır.',
          'PARRAFO4_1':'•	Cultural Go®, SuccessGo® ',
          // 'PARRAFO4_2':'Innovación Tecnológica B&M S.A. de C.V. nin tescilli ticari markasıdır. Meksika',
          'PARRAFO4_2':'ve genel olarak Go!® platformunun tamamı geliştiricinin tescilli ticari markalarıdır.',
          'PARRAFO5':'Teşekkür ederim!!',
          'BTN_FINALIZAR':'Bitir ve Gönder',
          'BTN_FINA_REQUE ':' Bitmiş Teknik Gereksinimler ',


        },
        'COPY_MESSAGE':'Anahtar panoya kopyalandı',
        'COMPR_CONEXI':'Bağlantıyı kontrol etme',
        'SUCCES_CONF_EMA':{
        'MODAL_SUCCESS':'Posta alımı doğrulandı',
        'MODAL_INSTRUCCI':'Lütfen sekmeyi kapatın',
        },
        'FORMULARIO_TI': {
          'TAB': 'Sürecin sonu',
          'TITULO': 'İnceleyen ayrıntıları',
          'SUBTITULO': 'İşlemi tamamlamak için aşağıdaki forma verilerinizi girin ve Bitir butonuna tıklayın.',
          'DONE': 'süreç çoktan bitti',
          'FINALIZAR': 'Teknik gereksinimleri sonlandırın',
          'NOTYET': 'BT yöneticisi süreci tamamlamadı, BT yöneticisi verilerini girene kadar teknik gereksinimleri onaylayabilecektir.',
          'FORM': {
            'NOMBRE': 'İsim',
            'MAIL': 'E-posta',
            'FECHA': 'Bitiş tarihi',
            'SINENVIAR': 'Veriler henüz gönderilmedi'
          },
          'MENSAJES': {
            'NOMBRE': 'Belirtilen alana adınızı girmediniz',
            'GUARDANDO': 'Girdiğiniz bilgiler kaydediliyor, lütfen biraz bekleyin',
            'GUARDADO': 'Veriler doğru şekilde kaydedildi'
          }
        },
          'ETI_EMPRE':'Şirket:',
          'CONTAC':'Bize ulaşın:',
         'CONTAC_DES':'Size nasıl yardımcı olabiliriz?',
         'SEND_EMA':'Mesaj gönder',
         'LABEL':'Açıklama',
         'TEX_BTN_SEND':'Gönder',
         'MODA_SEN_EMAI':'Mesaj gönderiliyor...',
         'SUCC_MODA_SEN_EMAI':'Mesaj başarıyla gönderildi',

    }
  }
};
